export const API_KEY = "74f4ffed4a687118b2e877081f050d22";
